<!--跟进线索-->
<template>
  <div class="root-container">
    <el-form label-position="center"  ref="CuleRef":model="param" :rules="rules" label-width="140px">
      <el-form-item label="姓名:" >
        <el-input readonly=true v-model="info.childName" style="width: 300px;"></el-input>
      </el-form-item>
      <el-form-item label="小名:" >
        <el-input readonly=true v-model="info.childPetName" style="width: 300px;"></el-input>
      </el-form-item>
      <el-form-item label="手机号:" >
        <el-input readonly=true v-model="info.userPhone" style="width: 300px;"></el-input>
      </el-form-item>

      <el-form-item label="意向级别:"  prop="intention">
        <el-select  v-model="param.intention" placeholder="请选择" @change="onChaneWork" style="width: 300px;">
          <el-option
            v-for="item in intentions"
            :key="item.v"
            :label="item.des"
            :value="item.v">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="跟进人:"  prop="followUpWorkerId" >
        <el-select  v-model="param.followUpWorkerId" placeholder="请选择" style="width: 300px;">
          <el-option
            v-for="item in allWorker"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="跟进阶段:"  prop="followUpStage">
        <el-select v-model="param.followUpStage" placeholder="请选择" @change="onChangeFollowUpStage" style="width: 300px;">
          <el-option
            v-for="item in followStages"
            :key="item.v"
            :label="item.des"
            :value="item.v">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="下一次跟进日期:"  >
        <el-date-picker style="width: 300px;"
          v-model="param.nextFollowDay"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="备注:" >
        <el-input
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 20}"
          placeholder=""
          maxlength="200"
          show-word-limit
          v-model="param.remark" style="width: 300px;">
        </el-input>
      </el-form-item>
      <el-form-item label="音频文件：">
            <el-upload
              :action="uploadAction"
              :headers="importHeaders"
              :file-list="uploadFileList"
              :on-success="handleUploadSuccess"
              :on-remove="handleUploadRemove"
              accept=".mp3"
              :limit=1
              list-type="file">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传mp3文件,数量限制为1</div>
            </el-upload>  
          </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer-1" >
      <el-button type="primary" size="medium" class="operator-btn" style="width: 120px;" @click="onClickSure('CuleRef')">确认</el-button>
    </div>
  </div>
</template>

<style scoped>

</style>

<script>


  import {EAllFollowStage, EAllIntention} from "../../../utils/enumsUtil";
  import commonUtils from "../../../utils/commonUtils";
  import {createOneClueRecord, followCreateOneClueRecord} from "../../../api/MktClueManager";
  import messageUtils from "../../../utils/messageUtils";
  import globaldata from "../../../utils/globaldata";
  import timeUtils from "../../../utils/timeUtils";
  import {getClueFollowSetting} from "../../../api/StoreSetting";
  import {formatDate} from "../../../utils/date";
  import {getStaticData} from "@/api/staticData";
  import { getToken } from '@/utils/auth'
  export default {
    name: 'FollowCule',
    props: {
      info:Object,
      allWorker:Array
    },
    data() {
      return {
        rules:{
          intention:[{required:true,message:"请选择意向级别",trigger:["blur",'change']}],
          followUpWorkerId:[{required:true,message:"请选择跟进人",trigger:["blur",'change']}],
          followUpStage:[{required:true,message:"请选择跟进阶段",trigger:["blur",'change']}],

        },
        intentions:[],//意向级别列表
        followStages:[],//跟进阶段列表

        param:{
          intention:'',
          followUpWorkerId:"",
          followUpStage:"",
          nextFollowDay:"",//下一次跟进日期
          remark:"",
        },

        clueSetting:{},

        //根据设置计算下次跟进日期和重新跟进日期
        nextFollowDay:"",
        nextReFollowDay:"",
        importHeaders:'',
        uploadAction:'',
        uploadFileList:[],
        fileDataList:[],
      }
    },
    created(){
     
    },
    mounted(){
      this.initData();
      let mytoken = getToken();
      this.importHeaders  = {"Authorization": mytoken}
      let param = {
        storeFrontId:globaldata.getAdminStore().storeFrontId,
      }
      getStaticData("").then(response =>
      {
        let data = response.data;
        if (commonUtils.isObjectNull(data)){
          return;
        }
        this.uploadAction = data.uploadChildPhotoImageUrl+'/'+param.storeFrontId;
      })
    },
    methods: {

      initData(){
        this.intentions = EAllIntention()
        this.followStages = EAllFollowStage()
        this.onGetClueFollowSetting()
        this.fileDataList=[]
        this.uploadFileList=[]

      },


      handleUploadSuccess(res, file){
        if(res.code != 20000){
          messageUtils.errorMsg(this,res.message)
          return
        }
        messageUtils.successMsg(this,"上传成功");
        let fileData={
          fileName:file.name,
          filePath:res.data,
          uid:file.uid,
        }
        this.fileDataList.push(fileData)
      },

      handleUploadRemove(file){
        let id1 = this.fileDataList.findIndex(item => {
              if (item.uid === file.uid) {
                  return true
              }
        })
        this.fileDataList.splice(id1, 1)
      },

      //计算下次跟进与重新跟进日期
      calculateNextFollow(){
        let nowData = new Date();
        this.nextFollowDay  = timeUtils.getBeforeDayOfDate(nowData,this.clueSetting.defaultNextFollowClueDay*-1);
        this.nextReFollowDay    = timeUtils.getBeforeDayOfDate(nowData,this.clueSetting.defaultNextReFollowClueDay*-1);

      },
      onClickSure(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let   nextFollowDay = 0;
            if (commonUtils.isStringNull(this.param.nextFollowDay) == false){
              nextFollowDay = timeUtils.transDayInt(this.param.nextFollowDay )
            }
            console.log("onClickSure nextFollowDay ",nextFollowDay,this.param.nextFollowDay)
            let param = {
              id:this.info.id,
              storeFrontId:globaldata.getAdminStore().storeFrontId,
              adminId:globaldata.getAdminStore().id,
              userId:this.info.userId,
              intention:this.param.intention,
              followUpWorkerId:this.param.followUpWorkerId,
              followUpStage:this.param.followUpStage,
              nextFollowDay:nextFollowDay,
              remark:this.param.remark,
              fileDataList:this.fileDataList,
            }

            const loading = this.myLoading();
            followCreateOneClueRecord(param).then(response =>
            {
              loading.close();
              let data = response.data;
              if (commonUtils.isObjectNull(data)){
                return;
              }
              if (data == true){
                messageUtils.successMsg(this,response.message)
              }else {
                messageUtils.errorMsg(this,response.message)
              }
              this.$emit('onFollowSuccess')

            })

          }
        });
      },

      onGetClueFollowSetting(){
        let param = {
          id:globaldata.getAdminStore().storeFrontId
        }
        getClueFollowSetting(param).then(response =>
        {
          let data  = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.clueSetting.defaultNextFollowClueDay = data.defaultNextFollowClueDay;
          this.clueSetting.defaultNextReFollowClueDay = data.defaultNextReFollowClueDay;
          this.calculateNextFollow();
        })

      },

      onChangeFollowUpStage(val){


        if (val == 5 || val == 6){
          //表示线索完成 下次重新跟进的日期
          this.param.nextFollowDay = formatDate( this.nextReFollowDay,"yyyy-MM-dd");
        } else {
          //下次跟进的日期
          this.param.nextFollowDay =formatDate( this.nextFollowDay,"yyyy-MM-dd");
        }

      }

    },


  }
</script>






// WEBPACK FOOTER //
// src/views/marketing-manager/components/FollowClue.vue